import KinvaDocUpdate from './KinvaDocUpdate'
export {KinvaDocUpdate}
export default KinvaDocUpdate
